// src/hooks/useDocumentInfo.js
import {  useMemo } from 'react';

/**
 * Custom Hook to find a document or version by ID,
 * and expose both the found item and its version number.
 */
export function useDocumentInfo(id, marketingData = [], archivedData = []) {
  // 1) Memoize the search results so we only recompute when inputs change
  const { foundItem, version } = useMemo(() => {
    if (!id) {
      return { foundItem: null, version: null };
    }

    // Helper to find item in an array
    const findById = arr =>
      arr.find(item =>
        item.documentId === id ||
        item.version?.some(v => v.versionId === id)
      );

    // Try marketingData first, then archivedData
    const item = findById(marketingData) ?? findById(archivedData);
    if (!item) {
      return { foundItem: null, version: null };
    }

    // If the ID matches a version, use that versionNumber; otherwise fall back to firstVersion
    const matched = item.version?.find(v => v.versionId === id);
    const versionNumber = matched?.versionNumber ?? item.firstVersion ?? null;
    return { foundItem: item, version: versionNumber };
  }, [id, marketingData, archivedData]);

  // 2) Synchronize component state via side effects
  // (Optional: you could return foundItem/version and let the caller handle setState)
  return { foundItem, version };
}

